import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppSettings } from "../../proyect.conf";
import { PoliticaVinculacion } from "../_models/politica-vinculacion";
import { AutenticacionService } from './autenticacion.service';
import {PoliticaDescarteVinculacion} from '../_models/politica-descarte-vinculacion';

@Injectable({
  providedIn: "root",
})
export class PoliticasDescartesVinculacionesService {
  private rutServicio = AppSettings.rutServiciosPOLITICA + "/api/politicasDescartesVinculaciones";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listadoPoliticasVinculaciones() {
    return this.httpClient
      .get(this.rutServicio)
      .pipe(map((res) => res as PoliticaDescarteVinculacion[]));
  }

  listadoPoliticasVinculacionesHabilitados() {
    return this.httpClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as PoliticaDescarteVinculacion[]));
  }

  listadoIdPolitica(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica)
      .pipe(map((res) => res as PoliticaDescarteVinculacion[]));
  }

  listadoIdPoliticaEnabled(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica + "/enabled" )
      .pipe(map((res) => res as PoliticaDescarteVinculacion[]));
  }


  obtenerPorId(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/" + id)
      .pipe(map((res) => res as PoliticaDescarteVinculacion));
  }

  crear(regCrear: PoliticaDescarteVinculacion) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as PoliticaDescarteVinculacion));
  }

  actualizar(regActualizar: PoliticaDescarteVinculacion) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as PoliticaDescarteVinculacion));
  }

  bulk(registros: PoliticaDescarteVinculacion[]) {
    registros.map((s: PoliticaDescarteVinculacion) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient
      .post(this.rutServicio + "/bulk", registros)
      .pipe(map((res) => res as PoliticaDescarteVinculacion[]));
  }
}
